var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.data != null && _vm.data.length > 0
        ? _c("box", { attrs: { title: "Document" } }, [
            _c(
              "ol",
              { attrs: { slot: "content" }, slot: "content" },
              _vm._l(_vm.data, function(item) {
                return _c("li", { key: item.id }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.createUrl(item.id, item.uniqueID),
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v("\n               "),
                      _c("i", { class: _vm.createIcon(item.mineType) }),
                      _vm._v("   " + _vm._s(item.orgFileName))
                    ]
                  )
                ])
              })
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-585be42a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-585be42a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/related-document-task.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-585be42a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/related-document-task.vue
// module chunks = 2 3